module.exports = __webpack_public_path__ + "assets/img/main_img_carousel_3.30f5443c.png";